import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useCallback,
  useImperativeHandle,
  useMemo,
} from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import {
  getInitFormData,
  getNoSlip,
  applySlip,
  CalAmBulk,
  CalAm,
} from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SharedForm from "../../../../../widgets/SharedForm";
import { fnSave } from "@shared/api/restApi";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "@widgets/CommonDialog";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnResizable from "@shared/components/SnResizable";
import usePanelSizes from "@shared/hooks/usePanelSizes";
import { showPopupModal } from "@widgets/CommonModal";
import SnForm, { ValueChangedEvent } from "@widgets/SnForm";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import SN_TRA_EOF_REG_001_POP_001 from "./SN_TRA_EOF_REG_001_POP_001";
import SN_TRA_EOF_REG_001_POP_002 from "./SN_TRA_EOF_REG_001_POP_002";
import SnButton from "@shared/components/SnButton";

interface Props {
  Menuprops: menuInfo;
  modalRef?: any;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_TRA_EOF_REG_001 = forwardRef(({ Menuprops, modalRef }: Props, ref) => {
  //#region  variable
  const { userInfo } = global(); // Login user 정보
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
  });
  const [columns, setColums] = useState<any>({
    grid1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
  });
  const formRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    freeform1: React.createRef(),
  });
  const [formControls, setFormControls] = useState<any>({
    freeform1: [],
  });
  const [formDatas, setFormDatas] = useState<any>({
    freeform1: null,
  });
  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
  //#endregion

  //#region  Components useState
  //#endregion

  //#region panel 사이즈 관련
  const cd_menu = Menuprops.cd_menu || "SN_TRA_EOF_REG_001";
  const defaultSize = {
    panel1height: "63.5%",
    panel2height: "35.5%",
    panel3width: "1.5%",
  };
  const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize); // SnResizable들의 크기

  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setColums({
          grid1: rtn.grid.grid2,
        });
        setFormControls({
          freeform1: rtn.form.freeform1,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));
  //region OnSearch
  const onSearch = async () => {
    const modifiedRowsH = formRefs.current["freeform1"].current.getChange();
    const modifiedRowsL = gridRefs.current["grid1"].current.getChange();

    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        await onSave();
      }
    }
    try {
      await search_popup();
    } catch (error) {}
  };
  //region getPopupInitialData
  const getPopupInitialData = () => {
    let cd_cust = "";
    let nm_cust = "";

    const rowCount = gridRefs.current["grid1"].current.getDisplayedRowCount();
    if (rowCount > 0) {
      const rowNode = gridRefs.current["grid1"].current.getSelectedRows(0); // always one row
      if (rowNode?.data) {
        cd_cust = cd_cust || rowNode.data.cd_cust || "";
        nm_cust = nm_cust || rowNode.data.nm_cust || "";
      }
    }

    return { cd_cust, nm_cust };
  };
  //region search_popup
  const search_popup = async () => {
    const selectedData = getPopupInitialData();

    const component = (
      <SN_TRA_EOF_REG_001_POP_001 selectedData={selectedData} />
    );
    const result = await showPopupModal({
      title: "OFFER조회",
      children: component,
    });
    if (!result || result === "close") return;
    const headerResult = result[0];
    const newData = { no_est: headerResult[0].no_est };
    const params = {
      id: "sn_tra_eof_reg_001_01",
      params: { ...newData },
    };
    const data: any = await fnGetDataSet(params);
    setFormDatas({
      freeform1: data[0][0],
    });
    setDataSources({
      grid1: data[1] || [],
    });
  };

  //region OnInsert
  const onInsert = async () => {
    try {
      const modifiedRowsH = formRefs.current["freeform1"].current.getChange();

      if (modifiedRowsH.modifiedRowcount > 0) {
        const confirm = await showDialog(
          "confirm",
          "수정중인 건이 있습니다. 저장하지 않고 계속 하시겠습니까?"
        );
        if (!confirm) return;
      }
      formRefs.current["freeform1"].current.resetUpdate();
      gridRefs.current["grid1"].current?.deleteAllRows();
      gridRefs.current["grid1"].current.resetUpdate();

      const newRow = {
        cd_firm: userInfo.cd_firm,
        cd_biz: userInfo.cd_biz,
        cd_dept: userInfo.cd_dept,
        nm_dept: userInfo.nm_dept,
        cd_gp: userInfo.cd_gp,
        nm_gp: userInfo.nm_gp,
        cd_emp: userInfo.cd_emp,
        nm_emp: userInfo.nm_emp,
        dt_est: todayform,
        cd_exch: "002",
        fg_trns: "4",
        no_hst: "1",
      };
      formRefs.current["freeform1"].current.addRow(newRow);
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };
  //region onDelete
  const onDelete = async () => {
    if (!formRefs.current["freeform1"].current.checkDataExist()) {
      return;
    }
    const confirm = await showDialog("confirm", "삭제 하시겠습니까?");

    if (!confirm) {
      return;
    }

    gridRefs.current["grid1"].current?.deleteAllRows();
    formRefs.current["freeform1"].current?.deleteForm();

    return await onSave();
  };

  //region onAddRow
  const onAddRow = async () => {
    try {
      const modifiedRowH = formRefs.current["freeform1"].current.getChange();
      if (modifiedRowH.insert.length == 0) {
        await showDialog("alter", "신규행을 추가하시기 바랍니다.");
        return;
      }
      const maxNoLine =
        gridRefs.current["grid1"].current.getMaxValue("no_line");
      const formData = formRefs.current["freeform1"].current.getFormdata();
      const noest = formData?.no_est;
      const newRow = {
        cd_firm: userInfo.cd_firm,
        no_est: noest,
        dt_dlv: todayform,
        no_hst: 1,
        no_line: maxNoLine + 1,
      };
      return gridRefs.current["grid1"].current?.addRow(newRow);
    } catch (error: any) {}
  };

  //region onDeleteRow
  const onDeleteRow = async () => {
    const selectedRows =
      gridRefs.current["grid1"].current?.getSelectedRows?.() || [];
    if (selectedRows.length === 0) return;

    const hasSavedRow = selectedRows.some((row: any) => row.state !== "insert");

    if (hasSavedRow) {
      await showDialog("alert", "저장된 데이터는 삭제할 수 없습니다.");
      return;
    }
    gridRefs.current["grid1"].current?.deleteSelectedRows();
  };
  //region OnSave
  const onSave = async () => {
    let salEsthChanges;
    let salEstlChanges;
    try {
      gridRefs.current["grid1"].current.stopEditing();

      const requiredValuesCheckH =
        formRefs.current["freeform1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return;
      }
      const requiredValuesCheckL =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckL) {
        return;
      }

      salEsthChanges = formRefs.current["freeform1"].current.getChange();
      salEstlChanges = gridRefs.current["grid1"].current.getChange();

      const headerInserts = salEsthChanges.insert ?? [];
      const lineInserts = salEstlChanges.insert ?? [];

      if (
        salEsthChanges.modifiedRowcount === 0 &&
        salEstlChanges.modifiedRowcount === 0
      ) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      // 채번 처리
      if (headerInserts.length !== 0) {
        const noSlip = await applySlip({
          cd_column: "no_est",
          cd_module: Menuprops.cd_module,
          no_line: 1,
          cd_prefix: "EOF",
          dt: headerInserts[0]?.dt_est,
          girdrefs: [gridRefs.current["grid1"]],
          formrefs: [formRefs.current["freeform1"]],
          inserts: [salEsthChanges, salEstlChanges],
          cd_menu: Menuprops.cd_menu,
        });
      }

      const SaveData = {
        sal_esth: salEsthChanges,
        sal_estl: salEstlChanges,
      };
      await fnSave("SN_TRA_EOF_REG_001_SAVE_01", SaveData);

      formRefs.current["freeform1"].current.resetUpdate();
      gridRefs.current["grid1"].current.resetUpdate();
    } catch (error: any) {}
  };

  //region onFocusedRowChanged
  //region OnValueChanged
  const onValueChaged = async (event: ValueChangedEvent) => {
    if (!event) return;

    const colId = event.colId;
    const rowData = event.rowData;

    await CalAmBulk(
      formRefs.current["freeform1"],
      gridRefs.current["grid1"],
      colId
    );
  };
  const onBeforeAddRowL = () => {
    try {
      const maxNoLine =
        gridRefs.current["grid1"].current.getMaxValue("no_line");
      const formData = formRefs.current["freeform1"].current.getFormdata();
      const noest = formData?.no_est;
      return {
        cd_firm: userInfo.cd_firm,
        no_est: noest,
        dt_dlv: todayform,
        no_hst: 1,
        no_line: maxNoLine + 1,
      };
    } catch (error: any) {
      return false;
    }
  };
  //region calculateAmounts
  //#region onCellValueChanged
  const onCellValueChangedL = async (event: CellValueChangedEvent) => {
    if (!event) return;

    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;
    const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
    if (colId === "um_std_est") {
      const result =
        rowData.um_std_est * (1 - focusedNodeH.data.rt_margin / 100);
      const um = isNaN(result) ? 0 : result;
      rowNode.setDataValue("um", um);
    } else if (colId === "rt_margin") {
      const result =
        focusedNodeH.data.um_std_est * (1 - rowData.rt_margin / 100);
      const um = isNaN(result) ? 0 : result;
      rowNode.setDataValue("um", um);
    }
    await CalAm(
      formRefs.current["freeform1"],
      gridRefs.current["grid1"],
      colId
    );
  };
  const onAfterSetFooter = async (data: any) => {
    if (!data) return;
    formRefs.current["freeform1"].current.setDataValue(
      "am",
      data.am,
      "noEvent"
    );
    formRefs.current["freeform1"].current.setDataValue(
      "am_k",
      data.am_k,
      "noEvent"
    );
  };
  //#endregion
  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onCellValueChanged: onCellValueChangedL,
          onBtnDeleteClick: onDeleteRow,
          onBtnAddClick: onAddRow,
          onAfterSetFooter: onAfterSetFooter,
          onBeforeAddRow: onBeforeAddRowL,
        },
      },
    }),
    [columns, dataSources]
  );
  const forms = useMemo(
    () => ({
      freeform1: {
        controls: formControls.freeform1,
        data: formDatas.freeform1,
        etcProps: {},
        events: {
          onValueChanged: onValueChaged,
        },
      },
    }),
    [formControls, formDatas]
  );
  //#region  UI
  return (
    <div className="h-full flex flex-col">
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizable
          direction={"height"}
          seq={1}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel1height}
          onResizeStop={onResizeStop}
          enable={{ bottom: true }}
          minHeight={130}
        >
          <SnForm
            ref={formRefs.current["freeform1"]}
            data={forms.freeform1.data}
            controls={forms.freeform1.controls}
            etcProps={forms.freeform1.etcProps}
            events={forms.freeform1.events}
          ></SnForm>
        </SnResizable>
        <SnResizable
          direction={"height"}
          seq={2}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel2height}
          onResizeStop={onResizeStop}
          enable={{ bottom: true }}
          minHeight={130}
        >
          <SnGrid
            ref={gridRefs.current["grid1"]} // Grid Name
            columnConfig={grids.grid1.columns} // 컬럼 설정 전달
            rowData={grids.grid1.dataSource} // Datasource
            etcProps={{
              isEditable: true,
              rowSelection: "multiple",
              title: "상세정보",
            }}
            events={grids.grid1.events}
          />
        </SnResizable>
      </div>
    </div>
  );
  //#endregion
});
export default SN_TRA_EOF_REG_001;
